import React from "react";
import { MapPinIcon, QuoteIcon, StarIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { SectionHeading } from "./SectionHeading";
import { testimonials } from "../data/landing";
export function Testimonials() {
  return <section className="bg-slate-100 px-4 py-16 sm:py-20" aria-labelledby="testimonials" data-id="element-271" data-mp="3fxkueaow05jz">
      <div className="mx-auto max-w-5xl" data-id="element-272" data-mp="3b0ax68v9apll">
        <SectionHeading tone="light" title={<span id="testimonials" data-id="element-274" data-mp="370aicn48wce0">What other physiotherapists say</span>} intro="Feedback from professionals who have used the Blueprint." data-id="element-273" data-mp="36ypqj59bf7ju" />

        <div className="grid gap-5 md:grid-cols-2" data-id="element-275" data-mp="2x004r1eat2yb">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6 shadow-sm ring-1 ring-slate-200" data-id="element-276" data-mp="2s28c255txct2">
              <div className="flex items-center justify-between" data-id="element-277" data-mp="v8dkrjstq8bc">
                <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-278" data-mp="qalibvujz3sw">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-gold text-gold" aria-hidden="true" data-id="element-279" data-mp="h559bys2ppvi" data-mpi={i} />)}
                </div>
                <QuoteIcon className="h-8 w-8 text-slate-200" aria-hidden="true" data-id="element-280" data-mp="m2onkyoru2ng" />
              </div>
              <blockquote className="mt-4 text-[16px] leading-relaxed text-slate-700" data-id="element-281" data-mp="7a4yh1yghvp0">"{t.quote}"</blockquote>
              <figcaption className="mt-auto flex items-center gap-4 border-t border-slate-100 pt-5" data-id="element-282" data-mp="zwg08fxsu2ne">
                <img src={t.photo} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-cyan/30" loading="lazy" data-id="element-283" data-mp="14v9cy659hpmi" />
                <div data-id="element-284" data-mp="q5v2svtv3462">
                  <p className="text-[16px] font-bold text-ink" data-id="element-285" data-mp="q6cx3mwyr8bc">{t.name}</p>
                  <p className="text-[13px] text-slate-600" data-id="element-286" data-mp="v4emsqowa5vs">{t.role}</p>
                  <p className="mt-0.5 flex items-center gap-1 text-[13px] font-medium text-slate-500" data-id="element-287" data-mp="1iusay64czkl3">
                    <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-288" data-mp="1nma7mhzcmz09" />
                    {t.location}
                  </p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <p className="mx-auto mt-6 max-w-2xl text-center text-[12px] leading-relaxed text-slate-500" data-id="element-289" data-mp="1sjfmp9q8pa9o">
          Testimonials shown are illustrative examples and will be replaced with authorized customer reviews.
        </p>

        <div className="mt-10 rounded-3xl bg-ink px-4 py-10" data-id="element-290" data-mp="1jkc221bfcmt2">
          <CtaButton label="I want to explore the Blueprint" data-id="element-291" data-mp="1ejwrfhij1tes" />
        </div>
      </div>
    </section>;
}